(function () {
	'use strict';
	
	var forms = new forms4i();
	var isRegistrationPage = document.getElementsByClassName("RegistrationForm")[0];
	var phoneMaskPattern, allSaleChecks, allProductChecks, allNewsChecks;	
	
	if(isRegistrationPage){
		if(document.getElementById("ZipCode")){
			if (document.getElementById("ZipCodeMask")) {
				var zipCodeMaskPattern = document.getElementById("ZipCodeMask").value;
				if (zipCodeMaskPattern != "") { // only used for CA
					VMasker(document.getElementById("ZipCode")).maskPattern(zipCodeMaskPattern);
				}
			}
		}
		
		forms.MaskPhoneNumber(document.getElementById("phoneMask"), document.getElementById("Phone"));
		forms.MaskPhoneNumber(document.getElementById("phoneMask"), document.getElementById("MobileNumber"));
		
		var saleSection = document.getElementById("SaleSection"),
		productSection = document.getElementById("ProductSection"),
		newsSection = document.getElementById("NewsletterSection");		
		if (saleSection) {
			allSaleChecks = [].slice.call(saleSection.getElementsByTagName('ul')[0].querySelectorAll("input[type='checkbox']"));
		}
		if (productSection) {
			allProductChecks = [].slice.call(productSection.getElementsByTagName('ul')[0].querySelectorAll("input[type='checkbox']"));
		}
		if (newsSection) {
			if (newsSection.getElementsByTagName('ul').length > 0) {
				allNewsChecks = [].slice.call(newsSection.getElementsByTagName('ul')[0].querySelectorAll("input[type='checkbox']"));
			}
		}
	}
	
	var verificationToken = document.getElementById("registerForm").getElementsByTagName('input')[0].getAttribute("value"),
	
	saveEmailPreferences = function(emailAddress) {
        	var emailPrefs = "";
		function updateThis(elements){
			elements.forEach(function(el, index, array) {
				if(el.value != ''){
					if(el.checked){	
						emailPrefs += el.value + ":true,";
					} else{
						emailPrefs += el.value + ":false,";
					}
				}
			});
		}
	
		if (allSaleChecks) { updateThis(allSaleChecks); }
		if (allProductChecks) { updateThis(allProductChecks); }
		if (allNewsChecks) { updateThis(allNewsChecks); }

		var newUserData = {
			emailPrefs : emailPrefs, 
			emailAddress : emailAddress 
		};
			        			
		fetch('/Esp/SaveNewUserSubscriptions', { 
			method: 'POST', 
			body: JSON.stringify(newUserData), 
			headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "__RequestVerificationToken": verificationToken }
		}).then(function(response){
			return  (response.ok) ? response.text() : []; // response.json() returns a promise
		}).then(function(response){
			// proceed after successful request
		}).catch(function(error){
			// place error handling here
		});
	},
	
	formSuccess = function() {			
		if (document.getElementById('Email') && document.getElementsByClassName("RegistrationForm")[0]) { 
    			saveEmailPreferences(document.getElementById('Email').value);
	    	} 
    	};
	
	/*if(document.getElementById("submitPassword")){ // CRB: I don't think this is used anywhere
		document.getElementById("submitPassword").addEventListener("click", function(e){
			forms.formValidation(document.getElementById("changePassForm"), formSuccess(), e);
		});
	}*/
	if(document.getElementById("btnSubmit")){
		document.getElementById("btnSubmit").addEventListener("click", function(e) { 
			if(document.getElementById("registerForm")){ // using this ID on all forms in registration
				forms.formValidation(document.getElementById("registerForm"), formSuccess, e);
			}
			/*if (document.getElementById('Email')) {
				if (document.getElementsByClassName("RegistrationForm")[0]) { 
		    			saveEmailPreferences(document.getElementById('Email').value);
		    		}
		    	}*/
		});
		if (isRegistrationPage) {
			document.getElementById("registerForm").addEventListener("submit", function(e) { 
			    document.getElementById("btnSubmit").disabled = true;
			});
		}
	}
	if(document.getElementById("submitSMSVerifyCode")){
		document.getElementById("submitSMSVerifyCode").addEventListener("click", function(e){
			if (document.getElementById('code').value == "") {
				e.preventDefault();
				if (document.getElementById("ErrorBox")) {
					document.getElementById("ErrorBox").parentNode.removeChild(document.getElementById("ErrorBox")); // fix for IE11
				}
				document.getElementsByClassName("errorMessage")[0].classList.remove("hide");
				document.getElementById('code').classList.add("input-validation-error");
				document.getElementById('code').setAttribute("aria-invalid", "true");
			}
		});
	}
})();